import React from "react";
import "./overlay.scss";
import { useDispatch, useSelector } from "react-redux";
import { closeOverlay } from "../../redux/overlay";

const Overlay = ({
  visible = false,
  onClick = () => {},
  blur = false,
  backgroundColor = "rgba(0, 0, 0, 0.5)",
  zIndex = 500,
  children,
  className = "",
  top,
  left,
  right,
  bottom,
}) => {
  const { show } = useSelector((state) => state.overlay);
  const dispatch = useDispatch()

  if (!show) return null;
  const stylePostion = {};
  if (top) stylePostion.top = top;
  if (left) stylePostion.left = left;
  if (right) stylePostion.right = right;
  if (bottom) stylePostion.bottom = bottom;

  const baseClass = "custom-overlay";
  const blurClass = blur ? " blur" : "";
  const finalClass = `${baseClass}${blurClass}${
    className ? ` ${className}` : ""
  }`;
  return (
    <div
      onClick={() => dispatch(closeOverlay())}
      className={finalClass}
      style={{ backgroundColor, zIndex, ...stylePostion }}
    >
      {children}
    </div>
  );
};

export default Overlay;
